import { Component } from 'react';

export default  class BaseComponent extends Component { 
}
